import Analytics from '@/utils/analytics';
import i18n from '@/utils/i18n';
import React from 'react';
import { BubbleProps } from 'react-native-gifted-chat';
import { ChatActionMessage } from './chat-action-message';
import { ChatDetails_ChatMessageOrderInvoiceFragment } from '@/types';
import { Message, OnOrderPressType } from './types';

type Props = BubbleProps<Message> & {
  onOrderPress: OnOrderPressType;
};

export const ChatMessageOrderInvoice: React.FC<Props> = ({
  onOrderPress,
  ...rest
}) => {
  const currentMessage = rest.currentMessage as Message;
  const orderInvoice =
    currentMessage.orderInvoice as ChatDetails_ChatMessageOrderInvoiceFragment;

  return (
    <ChatActionMessage
      {...rest}
      buttonText={i18n.t('view_order')}
      onPress={() => {
        Analytics.track('chat_message.view_invoice_button.press', {
          orderInvoiceUUID: orderInvoice.uuid,
        });
        // Chat message is always sent with a linked order
        // although orders relationship is optional
        onOrderPress(
          orderInvoice.order!.uuid,
          orderInvoice.order!.customer_facing_id,
        );
      }}
      title={i18n.t('invoice_available')}
    />
  );
};
